import { useState } from 'react'
import { Checkbox, Modal } from '@mantine/core'
import Box from '@/components/ui/Box'
import AddressForm from '@/components/ui/AddressForm'

// Mapping AddressForm field names → service_cases DB field names
const toDbFields = (values) => ({
    customer_address_name: values.name || '',
    customer_address_company: values.company || '',
    customer_address_1: values.address1 || '',
    customer_address_2: values.address2 || '',
    customer_address_city: values.city || '',
    customer_address_state: values.province_code || '',
    customer_address_postcode: values.zip || '',
    customer_address_country: values.country_code || '',
    customer_email: values.email || '',
    customer_phone: values.phone || '',
})

// Mapping service_cases DB field names → AddressForm field names
const toFormFields = (serviceCase) => ({
    name: serviceCase.customer_address_name || '',
    company: serviceCase.customer_address_company || '',
    email: serviceCase.customer_email || '',
    phone: serviceCase.customer_phone || '',
    address1: serviceCase.customer_address_1 || '',
    address2: serviceCase.customer_address_2 || '',
    city: serviceCase.customer_address_city || '',
    province_code: serviceCase.customer_address_state || '',
    zip: serviceCase.customer_address_postcode || '',
    country_code: serviceCase.customer_address_country || '',
})

export default function ServiceCaseAddress({ serviceCase, updateServiceCase }) {
    const [opened, setOpened] = useState(false)
    const [loading, setLoading] = useState(false)

    const [savingPermission, setSavingPermission] = useState(false)

    const updateAddressPermission = async (allowed) => {
        setSavingPermission(true)
        try {
            await updateServiceCase({ allow_us_customer_address: allowed })
        } catch {
            // The API hook displays the error; keep the persisted checkbox value.
        } finally {
            setSavingPermission(false)
        }
    }

    const handleSubmit = async (values) => {
        setLoading(true)
        await updateServiceCase(toDbFields(values))
        setLoading(false)
        setOpened(false)
    }

    return (
        <>
            <Box
                title="Adresse"
                globalAction={false}
                action={() => setOpened(true)}
                actionLabel="Modifier l'adresse"
            >
                <div className="flex flex-col">
                    <span className="text-gray-500 whitespace-pre-line">
                        {serviceCase.customer_address || "Pas d'adresse"}
                    </span>
                </div>
                {serviceCase.type === 'repair' && (
                    <Checkbox
                        mt="md"
                        label="Autoriser le client à saisir une adresse aux États-Unis"
                        description="Pour ce dossier uniquement. La saisie dans le backoffice reste libre."
                        checked={Boolean(serviceCase.allow_us_customer_address)}
                        disabled={savingPermission}
                        onChange={(event) =>
                            updateAddressPermission(event.currentTarget.checked)
                        }
                    />
                )}
            </Box>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Modifier l'adresse"
                centered
                size="lg"
                keepMounted={false}
            >
                <AddressForm
                    initialValues={toFormFields(serviceCase)}
                    onSubmit={handleSubmit}
                    loading={loading}
                />
            </Modal>
        </>
    )
}
